import React, { useRef, useState } from "react";

import open_case_image from "../../../../../../../assets/Chat/open_case_icon.svg";
import chat_add_user from "../../../../../../../assets/Chat/chat_add_user.svg";
import { useSelector, DefaultRootState, useDispatch } from "react-redux";
import { Message, Modal } from "../../../../../../BP2Components";
import NewChatSettings from "../../../ChatSettings/ManageChatUsers";

import ChatSettings from "./ChatSettings";
import { removeNameFromTitle } from "../../../ChatScripts";
import { useIntl } from "react-intl";
import ManageChatUsers from "../../../ChatSettings/ManageChatUsers";
import IntlMessages from "../../../../../../../util/IntlMessages";
import ChatChangeRoomName from "../../../ChatSettings/ChatChangeRoomName";
import { useChat } from "../../../../../../../context/ChatContext/ChatContext";
import { updateRoomName } from "../../../firebaseCRUD";
import { setChatSettings } from "../../../../../../../appRedux/actions/ChatSettings";

interface ChatMessagesTopBarProps {
   actionIdFromUrl: string | null;
   instanceId: string;
   chatRoomType: string;
}

const ChatMessagesTopBar: React.FC<ChatMessagesTopBarProps> = ({
   actionIdFromUrl,
   instanceId,
   chatRoomType,
}) => {
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [isRenameModalOpen, setIsRenameModalOpen] = useState<boolean>(false);

   const chatSettings = useSelector((state: DefaultRootState) => state.chatSettings);
   const { avatars } = useSelector(({ companies }: any) => companies);
   const user = useSelector((state: DefaultRootState) => state.user);

   const childRef = useRef<{ removeUsers: () => void }>(null);
   const intl = useIntl();

   const chatData = useChat();

   const dispatch = useDispatch();

   const checkIfRoomCreatedFromCase = () => {
      if (
         chatSettings?.currentRoom?.caseReference &&
         // if don have lenght === 3 - means that caseReference was from old chat or not valid
         chatSettings?.currentRoom?.caseReference.split("-").length === 3 &&
         chatSettings?.currentRoom?.instanceId
      ) {
         return true;
      } else return false;
   };

   const handleOpenCase = () => {
      if (checkIfRoomCreatedFromCase()) {
         window?.location?.assign(
            `/cases/${chatSettings?.currentRoom?.caseReference?.split("-")[0]}?actionId=${
               chatSettings?.currentRoom?.caseReference?.split("-")[0]
            }&mailBoxId=undefined&instanceId=${chatSettings?.currentRoom?.instanceId}`,
         );
      } else {
         Message.error(intl.formatMessage({ id: "chat.case.cannot.be.opened" }));
      }
   };

   //currently removed - no avatars available
   const renderRoomUsersAvatars = () => {
      if (!chatSettings?.currentRoom?.chatUsers || !avatars) return null;

      const commonElements = avatars
         .filter((item) => chatSettings?.currentRoom?.chatUsers?.includes(item?.userOldId))
         .slice(0, 4);

      return commonElements.map((user) => (
         <img
            key={user?.userOldId}
            src={user?.avatarUrl}
            alt="User Avatar"
            style={{ width: "24px", height: "24px", borderRadius: "50%", marginRight: "-5%" }}
         />
      ));
   };

   const [newRoomName, setNewRoomName] = useState<string>();

   const handleChangeRoomName = () => {
      if (newRoomName === "" || newRoomName === undefined) {
         setIsRenameModalOpen(false);
      } else {
         updateRoomName("rooms/", chatSettings?.currentRoom?.key, newRoomName);
         dispatch(
            setChatSettings({
               currentRoom: {
                  ...chatSettings.currentRoom,
                  title: newRoomName,
               },
            }),
         );
         setIsRenameModalOpen(false);
      }
   };

   // in child component we have function to remove user.
   // we pass this function to this file(parent component) becouse modal save is here (onOK)
   // and we want to keep correct file structure
   const handeSaveSettings = () => {
      if (childRef.current) {
         childRef.current.removeUsers();
      }
      setIsModalOpen(false);
   };

   return (
      <>
         <div className="chat-messages-topbar">
            {checkIfRoomCreatedFromCase() && (
               <div style={{ cursor: "pointer" }} onClick={() => handleOpenCase()}>
                  <img style={{ width: "32px", height: "40px" }} src={open_case_image} />
               </div>
            )}
            <div title={chatSettings?.currentRoom?.title} className="chat-messages-topbar__title">
               {chatSettings?.currentRoom?.type === "direct"
                  ? removeNameFromTitle(chatSettings?.currentRoom?.title, user?.firstName)
                  : chatSettings?.currentRoom?.title}
            </div>
            {chatRoomType === "private" && (
               <div className="chat-messages-topbar__right-buttons">
                  <div className="right-button__users">{renderRoomUsersAvatars()}</div>

                  <div
                     onClick={() => setIsModalOpen(true)}
                     className="right-button add-user-button"
                  >
                     <img style={{ width: "24px", height: "24px" }} src={chat_add_user} />
                  </div>
                  <div
                     onClick={() => setIsRenameModalOpen(true)}
                     style={{ marginRight: "17px", cursor: "pointer" }}
                  >
                     {" "}
                     <span className="material-symbols-outlined">edit</span>
                  </div>
                  <ChatSettings instanceId={instanceId} actionIdFromUrl={actionIdFromUrl} />
               </div>
            )}
         </div>
         <Modal
            topBarStyles={{ border: "none" }}
            isOpen={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            onOk={() => handeSaveSettings()}
            onOkText="zapisz"
            customOnOkClassName="custom-onOk-chat-modal-button"
            width={window?.innerWidth / 2}
            height={window?.innerHeight / 2}
         >
            <ManageChatUsers ref={childRef} setIsModalOpen={() => setIsModalOpen(false)} />
         </Modal>

         <Modal
            isOpen={isRenameModalOpen}
            onOk={() => handleChangeRoomName()}
            onOkText={intl.formatMessage({ id: "global.save" })}
            onCancel={() => setIsRenameModalOpen(false)}
            width={window?.innerWidth / 2.5}
            height={window?.innerHeight / 5}
            topBarStyles={{ border: "none", marginTop: "1rem" }}
         >
            <div className="new-chat-settings-container__change-room-name">
               <span className="change-room-name-label">
                  <IntlMessages id="chat.changeRoomName" />
               </span>
               <ChatChangeRoomName
                  chatSettings={chatSettings}
                  chatData={chatData}
                  setNewRoomName={setNewRoomName}
               />
            </div>
         </Modal>
      </>
   );
};

export default ChatMessagesTopBar;
